class PostSelection {
    constructor(product, defaultVariant) {
      this.product = product;
      this.defaultVariant = defaultVariant;
      this.selectedVariant = this.defaultVariant;
      this.selectedProductHandle = null;
      this.selectedProductVariants = null;
      this.atcBtns = document.querySelectorAll(".post-selection__atc-btn");
      this.checkoutBtn = document.querySelector(".post-selection__checkout-btn");
      this.infoContent = document.querySelector(".post-selection__info-content");
      this.itemsContainer = document.querySelector(".post-selection__items-container");
      this.variantOptions = document.querySelectorAll(".post-selection__variants-container input[type='radio']");
      this.variantOptionsCross = document.querySelectorAll(".post-selection__variants-cross input[type='radio']");
      this.upsellOptions = document.querySelectorAll(".post-selection__item input[type='checkbox']");
      this.overview = document.querySelector(".post-selection__overview");
      this.overviewList = document.querySelector(".post-selection__overview-list");
      this.overviewBtn = document.querySelector(".post-selection__overview-btn");
      this.insuranceInfoBtn = document.querySelector(".post-selection__insurance-info");
      this.infoBackBtn = document.querySelector(".post-selection__back-info");
      this.selectedProductFirstVariant = null;
        this.addAllBtn = document.querySelector("[data-add-all]");
      this._insuranceAutoAddedLockId = null;
      this._init();
      this.drawerShow = true;
      this.drawerOpened = false;
    }

    _init() {
      this._microModal();
      this._splide();
      this._showAllContent();
      this._events();
      // Insurance starts collapsed: card is the CTA, lock-picker + premie appear on activation
      this._renderLockPicker();
      this._showInsuranceExtras(false);
      this._updateInsuranceNote2();
      const mainItem = this._getSelectedVariant();
    //   const isMounted = mainItem.options.includes("Gemonteerd");
    //   this._updateInsuranceShields(isMounted);
      window.postSelectionInstance = this;
    }
  
    _showAllContent() {
      // Show all content sections at once
      document.querySelectorAll("[data-page]").forEach((item) => {
        item.style.display = "block";
      });
      
      // Show all category containers
      document.querySelectorAll(".post-selection__items-category").forEach((category) => {
        category.style.display = "block";
      });
      
      // Show cross-sale and services sections
      document.querySelectorAll(".post-selection__cross-sale, .post-selection__services").forEach((section) => {
        section.style.display = "block";
      });
      
      // Show summary and items container
      document.querySelector(".post-selection__summary").style.display = "flex";
      document.querySelector(".post-selection__items-container").style.display = "flex";
      
      // Show only checkout button, hide navigation buttons
      this._updateSingleStepButtons();
    }
  
    _updateSingleStepButtons() {
      // Hide navigation buttons (back, next)
      const backBtn = document.querySelector(".post-selection__back-btn");
      const nextBtn = document.querySelector(".post-selection__next-btn");
      const infoBackBtn = document.querySelector(".post-selection__back-info");
      
      if (backBtn) backBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
      if (infoBackBtn) infoBackBtn.style.display = "none";

      if (this.checkoutBtn) {
        this.checkoutBtn.style.display = "flex";
      }
      
      // Show overview
      if (this.overview) {
        this.overview.style.display = "block";
      }
    }
  
    _splide() {
      new Splide(".splide", {
        type: "loop",
        perPage: 1,
        pagination: false,
        interval: 3000,
        speed: 800,
        autoplay: true,
        cover: false,
      }).mount();
    }
  
    _microModal() {
      this.microModalOptions = {
        openTrigger: "data-micromodal-open",
        closeTrigger: "data-micromodal-close",
        openClass: "is-open",
        disableScroll: true,
        disableFocus: false,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        debugMode: false,
      };
      MicroModal.init(this.microModalOptions);
  
      const modal = document.querySelector(".modal");
      const section = modal.closest(".section");
  
      if (modal && section) {
        section.appendChild(modal);
      }
    }
  
    _events() {
      this.atcBtns.forEach((btn) =>
        btn.addEventListener("click", () => {
          this._handleATCBtn();
        })
      );
  
      this.checkoutBtn.addEventListener("click", () => {
        this._handleCheckoutBtn();
      });
  
      this.upsellOptions.forEach((input) => {
        input.addEventListener("change", (e) => {
          if (input.dataset.cross !== "false") {
            this._checkUpsellBasedOnCross(input);
            return;
          }
          if (input.name === "categorie_verzekering") {
            this._handleInsuranceToggle(input);
            return;
          }
          this._updatePrices();
          this._updateOverview();
          this._checkInsuranceItems();
          this._checkCrossVariant();
          this._checkServices(e);
        });
      });
  
      // Event delegation for the close button
      this.overviewList.addEventListener("click", (e) => {
        const closeBtn = e.target.closest(".post-selection__overview-item-close");
        if (closeBtn) {
          this._removeListItem(closeBtn.closest("li").dataset.variant);
        }
      });
  
      this.overviewBtn.addEventListener("click", (e) => {
        this.overviewBtn.classList.toggle("active");
      });
  
      if (this.insuranceInfoBtn) {
        this.insuranceInfoBtn.addEventListener("click", (e) => {
          this._showInsuranceInfo();
        });
      }

      if (this.infoBackBtn) {
        this.infoBackBtn.addEventListener("click", (e) => {
          this._hideInsuranceInfo();
        });
      }
  
      this.variantOptions.forEach((input) => {
        input.addEventListener("change", (e) => {
          let previousVariant = this.selectedVariant;
  
          this.selectedVariant = this._getSelectedVariant().id;
          
          this._updateURL();
          this._updatePrices();
          this._updateSelectedVariantText(e);
          this._updateOverview();
          this._updateInsuranceNote(e);
          this._checkInsuranceItems();
          this._updateDelivery();
          this._updateCrossVariants(e);
          this._checkCrossVariant();
        });
      });
  
      this.variantOptionsCross.forEach((input) => {
        input.addEventListener("change", (e) => {
          const selectedValue = e.target.value.replace("-cross", "");
          const optionToClick = [...this.variantOptions]
            .filter((input) => input.value === selectedValue)
            .pop();
  
          optionToClick.click();
        });
      });
  
      document.querySelectorAll('.post-selection__qty-selector').forEach(function(qtySelector) {
        const minusBtn = qtySelector.querySelector('.post-selection__qty-minus');
        const plusBtn = qtySelector.querySelector('.post-selection__qty-plus');
        const qtyValue = qtySelector.querySelector('.post-selection__qty-value');
        const addBtn = qtySelector.previousElementSibling; 
        const checkbox = qtySelector.closest('.post-selection__item').querySelector('input[type="checkbox"]');
  
        if (plusBtn) {
          plusBtn.addEventListener('click', function() {
            let qty = parseInt(qtyValue.textContent, 10);
            if (qty < 2) {
              qty++;
              qtyValue.textContent = qty;
              checkbox.checked = true;
              checkbox.dataset.quantity = qty;
              console.log('[PLUS] Checkbox checked:', checkbox.dataset.title, 'Qty:', checkbox.dataset.quantity);
              if (window.postSelectionInstance) {
                window.postSelectionInstance._updatePrices();
                window.postSelectionInstance._updateOverview();
                window.postSelectionInstance._checkInsuranceItems();
                window.postSelectionInstance._checkCrossVariant();
              }
            }
          });
        }
  
        if (minusBtn) {
          minusBtn.addEventListener('click', function() {
            let qty = parseInt(qtyValue.textContent, 10);
            if (qty > 1) {
              qty--;
              qtyValue.textContent = qty;
              checkbox.checked = true;
              checkbox.dataset.quantity = qty;
              console.log('[MINUS] Checkbox checked:', checkbox.dataset.title, 'Qty:', checkbox.dataset.quantity);
              if (window.postSelectionInstance) {
                window.postSelectionInstance._updatePrices();
                window.postSelectionInstance._updateOverview();
                window.postSelectionInstance._checkInsuranceItems();
                window.postSelectionInstance._checkCrossVariant();
              }
            } else {
              qtySelector.style.display = 'none';
              if (addBtn && addBtn.classList.contains('post-selection__add-btn')) {
                addBtn.style.display = 'flex';
              }
              checkbox.checked = false;
              checkbox.dataset.quantity = 0;
              console.log('[MINUS] Checkbox unchecked:', checkbox.dataset.title, 'Qty:', checkbox.dataset.quantity);
              if (window.postSelectionInstance) {
                window.postSelectionInstance._updatePrices();
                window.postSelectionInstance._updateOverview();
                window.postSelectionInstance._checkInsuranceItems();
                window.postSelectionInstance._checkCrossVariant();
              }
            }
          });
        }
      });
  
      document.querySelectorAll('.post-selection__add-btn').forEach(function(addBtn) {
        addBtn.addEventListener('click', () => {
          addBtn.style.display = 'none';
          const qtySelector = addBtn.nextElementSibling;
          if (qtySelector && qtySelector.classList.contains('post-selection__qty-selector')) {
            qtySelector.style.display = 'flex';
            const qtyValue = qtySelector.querySelector('.post-selection__qty-value');
            if (qtyValue) qtyValue.textContent = '1';
            const checkbox = qtySelector.closest('.post-selection__item').querySelector('input[type="checkbox"]');
            if (checkbox) {
              checkbox.checked = true;
              checkbox.dataset.quantity = 1;
              console.log('[ADD] Checkbox checked:', checkbox.dataset.title, 'Qty:', checkbox.dataset.quantity);
            }
            if (window.postSelectionInstance) {
              window.postSelectionInstance._updatePrices();
              window.postSelectionInstance._updateOverview();
              window.postSelectionInstance._checkInsuranceItems();
              window.postSelectionInstance._checkCrossVariant();
            }
          }
        });
      });
  
      // Prevent default checkbox toggle on label click
      document.querySelectorAll('.post-selection__item input[type="checkbox"]').forEach(function(checkbox) {
        checkbox.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false; 
        });
      });
  
      document.querySelectorAll('.post-selection__qty-plus').forEach(btn => {
        btn.addEventListener('click', () => { console.log('PLUS CLICKED'); });
      });
  
      // Added click on category block with data-insurance="true"
      document.querySelectorAll('.post-selection__items-category[data-insurance="true"]').forEach(function(categoryBlock) {
        categoryBlock.addEventListener('click', function(e) {
          if (e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'label') return;
  
          const checkbox = categoryBlock.querySelector('input[type="checkbox"]');
          if (checkbox) {
            checkbox.checked = true;
            checkbox.dataset.quantity = 1;
            if (window.postSelectionInstance) {
              window.postSelectionInstance._updatePrices();
              window.postSelectionInstance._updateOverview();
              window.postSelectionInstance._checkInsuranceItems();
              window.postSelectionInstance._checkCrossVariant();
            }
          }
        });
      });
      if (this.addAllBtn) {
        this.addAllBtn.addEventListener("click", (e) => {
          this._handleAddAllBtn();
        });
      }
    }
    

    _handleAddAllBtn() {
        const allItems = document.querySelectorAll(".post-selection__cross-sale  input[type='checkbox']");
       
        
        
       allItems.forEach((item) => {
        item.dataset.quantity = 2;
        item.checked = true;
        });
        if (window.postSelectionInstance) {
            window.postSelectionInstance._updatePrices();
            window.postSelectionInstance._updateOverview();
            window.postSelectionInstance._checkInsuranceItems();
            window.postSelectionInstance._checkCrossVariant();
        }
    }
  
    _showInsuranceInfo() {
      // Hide main content and show insurance info
      document.querySelector(".post-selection__summary").style.display = "none";
      document.querySelector(".post-selection__items-container").style.display = "none";
      document.querySelector(".post-selection__variants-container").style.display = "none";
      
      // Show insurance info section
      const insuranceInfo = document.querySelector(".post-selection__insurance-info-section");
      if (insuranceInfo) {
        insuranceInfo.style.display = "block";
      }
      
      // Show back button
      if (this.infoBackBtn) {
        this.infoBackBtn.style.display = "flex";
      }
      
      // Hide checkout button temporarily
      if (this.checkoutBtn) {
        this.checkoutBtn.style.display = "none";
      }
    }
  
    _hideInsuranceInfo() {
      // Show main content again
      document.querySelector(".post-selection__summary").style.display = "flex";
      document.querySelector(".post-selection__items-container").style.display = "flex";
      document.querySelector(".post-selection__variants-container").style.display = "block";
      
      // Hide insurance info section
      const insuranceInfo = document.querySelector(".post-selection__insurance-info-section");
      if (insuranceInfo) {
        insuranceInfo.style.display = "none";
      }
      
      // Hide back button
      if (this.infoBackBtn) {
        this.infoBackBtn.style.display = "none";
      }
      
      // Show checkout button again
      if (this.checkoutBtn) {
        this.checkoutBtn.style.display = "flex";
      }
    }
  
    _checkUpsellBasedOnCross(input) {
      input.checked = true;
  
      this._updatePrices();
      this._updateOverview();
      this._checkInsuranceItems();
      this._checkCrossVariant();
  
      const items = document.querySelectorAll(
        '.post-selection__items-container input[type="checkbox"][data-cross="true"], .post-selection__items-container input[type="checkbox"]:checked'
      );
      const itemsArray = Array.from(items).filter(item => {
        if (item.dataset.cross === "true") {
          return parseInt(item.dataset.quantity, 10) > 0;
        }
        return item.checked;
      });
    }
  
    _checkServices(e) {
      const item = e.target.closest(".post-selection__item");
      const isService = item.dataset.service === "true";
      if (isService) {
        const selectedService = e.target.value;
        const serviceItems = document.querySelectorAll(
          '.post-selection__item[data-service="true"] input[type="checkbox"]'
        );
  
        serviceItems.forEach((serviceItem) => {
          if (serviceItem !== e.target) {
            serviceItem.checked = false;
          }
        });
  
        this._updateOverview();
        this._updatePrices();
      }
    }
  
    _checkCrossVariant() {
      const selectedUpsells = this._getUpsellItems();
    //   console.log('[UPSSELL ITEMS]', selectedUpsells);
      const mainItem = this._getSelectedVariant();
  
    //   const isMounted = mainItem.options.includes("Gemonteerd");
      const isArtLock = selectedUpsells.some((item) =>
        item.title.toLowerCase().includes("art")
      );

      const crossSaleSection = document.querySelector(".post-selection__cross-sale");
      if (crossSaleSection) {
        crossSaleSection.style.display = isArtLock ? "none" : "flex";
      }
    }
  
    _updateCrossVariants(e) {
      const selectedCrossOption = [...this.variantOptionsCross].find(
        (input) => input.value === `${e.target.value}-cross`
      );
      if (selectedCrossOption) {
        selectedCrossOption.click();
      }
    }
  
    _updateDelivery() {
      const variantInventory = document.querySelector(
        ".post-selection__inventory variant-inventory"
      );
  
      if (variantInventory) {
        const variants = variantInventory.querySelectorAll("[data-variant-id]");
  
        variants.forEach((variant) => {
          variant.setAttribute("hidden", "");
        });
        variants.forEach((variant) => {
          if (+variant.dataset.variantId === this.selectedVariant) {
            variant.removeAttribute("hidden");
          }
        });
      }
    }
  
    _handleATCBtn(event) {
      this._updatePrices();
      MicroModal.show("modal-1", this.microModalOptions);
    }
  
    _handleCheckoutBtn() {
      this.checkoutBtn.querySelector(".post-selection__checkout-btn-inner").style.display = "none";
      this.checkoutBtn.querySelector(".post-selection__btn-loader").style.display = "flex";
  
      // Add the bike AND all upsells in ONE cart/add call so the drawer opens once
      // (was two separate adds → cart drawer opened twice in a row).
      const items = [
        { id: this.selectedVariant, quantity: 1 },
        ...this._getUpsellPayload(),
      ];

      this._addVariantsToCart(items, () => {
        this.drawerShow ? false : (window.location.href = "/cart");
      });
    }

    // Build the upsell line-item payload (does NOT add to cart): insurance gets the
    // stable Activatie property, value-0/included gift items are dropped, duplicates de-duped.
    _getUpsellPayload() {
      const insuranceInput = this._getInsuranceInput();
      const insuranceId = insuranceInput ? +insuranceInput.value : null;
      // Stable cart-line MERGE KEY — must stay constant or insurance splits into separate lines.
      const INSURANCE_NOTE = "Je ontvangt na bezorging een activatielink";

      return this._getUpsellItems()
        .map((item) => {
          const payload = { id: item.id, quantity: item.quantity };
          if (insuranceId && item.id === insuranceId) {
            payload.properties = { Activatie: INSURANCE_NOTE };
          }
          return payload;
        })
        .filter((item) => item.id !== 0)
        .reduce((acc, item) => {
          if (!acc.some((i) => i.id === item.id)) acc.push(item);
          return acc;
        }, []);
    }
  
    _getSelectedVariant() {
      const selectedOptions = [];
      const selected = document.querySelectorAll(
        ".post-selection__variants-container input[type='radio']:checked"
      );
  
      selected.forEach((input) => {
        const optionValue = input.value;
        selectedOptions.push(optionValue);
      });
  
      const matchedVariant = this.product.variants.find((variant) =>
        selectedOptions.every((optionValue) =>
          variant.options.includes(optionValue)
        )
      );
  
      return matchedVariant;
    }
  
    _getUpsellItems() {
      const items = document.querySelectorAll(
        '.post-selection__items-container input[type="checkbox"][data-cross="true"], .post-selection__items-container input[type="checkbox"]:checked'
      );
      const itemsArray = Array.from(items).filter(item => {
        if (item.dataset.cross === "true") {
          return parseInt(item.dataset.quantity, 10) > 0;
        }
        return item.checked;
      });
  
      let itemsToAdd = itemsArray.map((item) => {
        const qty = parseInt(item.dataset.quantity, 10) || 1;
        return {
          id: +item.value,
          quantity: qty,
          title: item.dataset.title,
          img: item.dataset.img,
          price: item.dataset.price,
        };
      });
  
      // Check for the selected variant
      const selectedVariant = document.querySelector('.product-info__product-picker-combo .media-swatch.is-selected.border');
      if (selectedVariant) {
        const leveringOption = document.querySelector('.post-selection__variants input[type="radio"]:checked');
        let variantId;
        let variantPrice;
        if (leveringOption && leveringOption.value === "Gemonteerd") {
          variantId = parseInt(selectedVariant.getAttribute('data-second-variant-id'), 10);
          variantPrice = parseInt(selectedVariant.getAttribute('data-second-variant-price'), 10);
        } else {
          variantId = parseInt(selectedVariant.getAttribute('data-first-variant-id'), 10);
          variantPrice = parseInt(selectedVariant.getAttribute('data-price'), 10);
        }
  
        const variantTitle = selectedVariant.getAttribute('data-title');
        const variantImg = selectedVariant.querySelector('img').getAttribute('src');
  
        const variantObj = {
          id: variantId,
          title: variantTitle,
          featured_image: variantImg,
          price: variantPrice
        };
  
        const alreadyInUpsell = itemsToAdd.some(item => item.id === variantObj.id);
        if (!alreadyInUpsell) {
          itemsToAdd.push({
            id: variantObj.id,
            quantity: 1,
            title: variantObj.title,
            img: variantObj.featured_image,
            price: variantObj.price,
          });
        }
      }
  
      console.log('[UPSSELL ITEMS] Final itemsToAdd:', itemsToAdd);
      return itemsToAdd;
    }
  
    _updateHeaderCounter() {
      fetch(window.Shopify.routes.root + "?sections=header")
        .then((res) => res.json())
        .then((htmlString) => {
          const parser = new DOMParser();
          const header = parser.parseFromString(htmlString.header, "text/html");
          const cartCount = header.querySelector(".header__cart-count");
          document.querySelector(".header__cart-count").replaceWith(cartCount);
        });
    }
  
    _updateSelectedVariantText(e) {
      const selectedValue = e.target.value;
      const selectedOption = e.target
        .closest(".post-selection__option")
        .querySelector(".post-selection__selected-option");
      if (selectedOption) {
        selectedOption.textContent = selectedValue;
      }
    }
  
    _updatePrices() {
      console.log('[UPDATE PRICES] called');
      const comparePrice = document.querySelector(".post-selection__compare-price");
      const totalPrice = document.querySelector(".post-selection__total-price");
      console.log('[PRICE ELEMENTS]', comparePrice, totalPrice);
      
      const matchedVariant = this.product.variants.find(
        (variant) => variant.id === this.selectedVariant
      );
      
      const upsellItems = this._getUpsellItems();
      console.log('[UPSSELL ITEMS]', upsellItems);
      
      const totalUpsellPrice = upsellItems
        .filter((item) => item.id !== 0)
        .reduce((acc, item) => {
          const price = parseFloat(item.price);
          const qty = item.quantity;
          console.log('[PRICE CALC]', item.title, 'price:', price, 'qty:', qty);
          return acc + (price * qty);
        }, 0);
        
      if (comparePrice) {
        comparePrice.textContent = this._formatPrice(
          matchedVariant.compare_at_price + totalUpsellPrice
        );
      }
      if (totalPrice) {
        totalPrice.textContent = this._formatPrice(
          matchedVariant.price + totalUpsellPrice
        );
      }
       const installmentPrice = document.querySelector(".post-selection__footer .klarna-in3-price");
        if (installmentPrice) {
        installmentPrice.textContent = this._formatPrice(((matchedVariant.price + totalUpsellPrice) / 3).toFixed(0));
        }
        const spraypayPrice = document.querySelector(".post-selection__footer .spraypay-price");
        if (spraypayPrice) {
        spraypayPrice.textContent = this._formatPrice(((matchedVariant.price + totalUpsellPrice) *  0.02327).toFixed(0));
        }
    }
  
    _updateOverview() {
      if (!this.overviewList) return;
      
      this.overviewList.innerHTML = "";
  
      const selectedVariant = this.product.variants.find(
        (variant) => variant.id === this.selectedVariant
      );
  
      // Add main variant
      this._addItemToList(
        this.product.title,
        this._formatPrice(selectedVariant.price),
        this.product.featured_image,
        this.selectedVariant
      );
  
      // Add upsells
      const upsellItems = this._getUpsellItems()
        .filter((item) => item.id !== 0)
        .reduce((acc, item) => {
          const idExists = acc.some((i) => i.id === item.id);
          if (!idExists) {
            acc.push(item);
          }
          return acc;
        }, []);
  
      upsellItems.forEach((upsell) => {
        this._addItemToList(
          upsell.title,
          this._formatPrice(upsell.price),
          upsell.img,
          upsell.id
        );
      });
    }
  
    _updateInsuranceNote(e) {
      const insuranceNote = e.target
        .closest(".post-selection__option")
        .querySelector(".post-selection__insurance-note");
  
      if (insuranceNote) {
        const insuranceDeny = insuranceNote.querySelector(".post-selection__insurance-deny");
        const insuranceApprove = insuranceNote.querySelector(".post-selection__insurance-approve");
        
        if (e.target.value === "Gemonteerd") {
          if (insuranceDeny) insuranceDeny.style.display = "none";
          if (insuranceApprove) insuranceApprove.style.display = "flex";
          this._updateInsuranceShields(true);
        } else {
          if (insuranceDeny) insuranceDeny.style.display = "none";
          if (insuranceApprove) insuranceApprove.style.display = "flex";
          this._updateInsuranceShields(true);
        }
      }
    }
  
    _updateInsuranceShields(show) {
      const productShields = document.querySelectorAll(".post-selection__item-product-shield");
      productShields.forEach((shield) => {
        shield.style.display = show ? "inline-flex" : "none";
      });
    }
  
    _checkInsuranceItems() {
      const insuranceCat = document.querySelector('.post-selection__items-category[data-insurance="true"]');
      if (!insuranceCat) return;

      const insuranceInput = this._getInsuranceInput();
      const hasArtLock = this._hasArtLock();

      // Integrity: insurance can't stay active without an ART-2 lock selected.
      if (insuranceInput && insuranceInput.checked && !hasArtLock) {
        insuranceInput.checked = false;
        this._insuranceAutoAddedLockId = null;
        this._showInsuranceExtras(false);
        this._updateOverview();
        this._updatePrices();
      }

      this._renderLockPicker();
      this._updateInsuranceNote2();
    }

    _getInsuranceInput() {
      const cat = document.querySelector('.post-selection__items-category[data-insurance="true"]');
      return cat ? cat.querySelector('input[name="categorie_verzekering"]') : null;
    }

    _getLockInputs() {
      return Array.from(
        document.querySelectorAll(
          '.post-selection__items-container .post-selection__item input[name="categorie_sloten"]'
        )
      ).filter((i) => i.dataset.cross === "false" && +i.value !== 0);
    }

    _getArtLockInputs() {
      return this._getLockInputs().filter((i) =>
        (i.dataset.title || "").toLowerCase().includes("art")
      );
    }

    // Eligibility: any checked ART lock counts, including a pre-included (free, value 0) one.
    _hasArtLock() {
      return Array.from(
        document.querySelectorAll(
          '.post-selection__items-container .post-selection__item input[name="categorie_sloten"]'
        )
      ).some(
        (i) =>
          i.dataset.cross === "false" &&
          i.checked &&
          (i.dataset.title || "").toLowerCase().includes("art")
      );
    }

    // Clicking the insurance card adds the recommended ART-2 lock in one go.
    _handleInsuranceToggle(input) {
      if (input.checked) {
        const artLocks = this._getArtLockInputs();
        const alreadyHas = this._hasArtLock();
        if (!alreadyHas && artLocks.length === 0) {
          // No ART-2 lock available on this product → insurance not possible.
          input.checked = false;
          this._showInsuranceExtras(false);
          this._updateInsuranceNote2();
          return;
        }
        if (!alreadyHas && artLocks.length > 0) {
          const recommended = artLocks[0];
          recommended.checked = true;
          this._insuranceAutoAddedLockId = recommended.value;
          recommended.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          // An ART lock is already present (included or chosen) — don't auto-remove it later.
          this._insuranceAutoAddedLockId = null;
        }
        this._showInsuranceExtras(true);
        this._renderLockPicker();
      } else {
        if (this._insuranceAutoAddedLockId) {
          const lock = this._getArtLockInputs().find(
            (l) => l.value === this._insuranceAutoAddedLockId
          );
          if (lock && lock.checked) {
            lock.checked = false;
            lock.dispatchEvent(new Event("change", { bubbles: true }));
          }
          this._insuranceAutoAddedLockId = null;
        }
        this._showInsuranceExtras(false);
      }
      this._updatePrices();
      this._updateOverview();
      this._updateInsuranceNote2();
    }

    // Swap the insurance lock from the picker (single-select among ART-2 locks).
    _selectLock(lockInput) {
      if (!lockInput) return;
      if (!lockInput.checked) {
        lockInput.checked = true;
        lockInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this._getArtLockInputs().forEach((l) => {
        if (l !== lockInput && l.checked) {
          l.checked = false;
          l.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      this._insuranceAutoAddedLockId = lockInput.value;
      this._renderLockPicker();
      this._updatePrices();
      this._updateOverview();
    }

    _showInsuranceExtras(show) {
      const picker = document.querySelector("[data-insurance-lock-picker]");
      const premie = document.querySelector(".ifkV9LZUP87pR2DLy");
      if (picker) {
        picker.hidden = !show || this._getArtLockInputs().length === 0;
      }
      if (premie) premie.style.display = show ? "block" : "none";
    }

    _renderLockPicker() {
      const container = document.querySelector("[data-insurance-lock-picker]");
      if (!container) return;

      // Only show the picker when a selectable (paid) ART lock is actually the chosen
      // insurance lock. If a free/included lock (e.g. a gift) already covers insurance,
      // there is no paid lock checked → hide the picker (the free lock shows in its own block).
      const artLocks = this._getArtLockInputs();
      const selected = artLocks.find((l) => l.checked);
      if (!selected) {
        container.innerHTML = "";
        container.hidden = true;
        return;
      }
      const includesLabel = container.dataset.includesLabel || "";
      const changeLabel = container.dataset.changeLabel || "";
      const requiredLabel = container.dataset.requiredLabel || "";
      const multiple = artLocks.length > 1;

      const thumbHtml = (l, cls) =>
        l.dataset.img
          ? '<img class="' + cls + '" src="' + l.dataset.img + '" alt="" loading="lazy">'
          : '<span class="' + cls + '"></span>';

      const optionsHtml = artLocks
        .map((l) => {
          const isSel = l === selected;
          return (
            '<button type="button" class="post-selection__insurance-lock-option' +
            (isSel ? " is-selected" : "") +
            '" data-lock-value="' + l.value + '">' +
            thumbHtml(l, "post-selection__insurance-lock-thumb") +
            '<span class="post-selection__insurance-lock-option-title">' + l.dataset.title + "</span>" +
            '<span class="post-selection__insurance-lock-option-price">' + this._formatPrice(l.dataset.price) + "</span>" +
            "</button>"
          );
        })
        .join("");

      container.innerHTML =
        '<div class="post-selection__insurance-lock-summary">' +
          thumbHtml(selected, "post-selection__insurance-lock-thumb") +
          '<span class="post-selection__insurance-lock-meta">' +
            '<span class="post-selection__insurance-lock-label">' + includesLabel + "</span>" +
            '<span class="post-selection__insurance-lock-current">' + selected.dataset.title + "</span>" +
          "</span>" +
          (multiple
            ? '<button type="button" class="post-selection__insurance-lock-toggle">' + changeLabel + "</button>"
            : "") +
        "</div>" +
        (requiredLabel
          ? '<p class="post-selection__insurance-lock-required">' + requiredLabel + "</p>"
          : "") +
        (multiple
          ? '<div class="post-selection__insurance-lock-options" hidden>' + optionsHtml + "</div>"
          : "");

      const toggle = container.querySelector(".post-selection__insurance-lock-toggle");
      const options = container.querySelector(".post-selection__insurance-lock-options");
      if (toggle && options) {
        toggle.addEventListener("click", () => {
          options.hidden = !options.hidden;
        });
      }
      container.querySelectorAll(".post-selection__insurance-lock-option").forEach((btn) => {
        btn.addEventListener("click", () => {
          const lock = this._getArtLockInputs().find(
            (l) => l.value === btn.dataset.lockValue
          );
          this._selectLock(lock);
          if (options) options.hidden = true;
        });
      });
    }

    _updateInsuranceNote2() {
      const note = document.querySelector(".post-selection__insurance-note--final");
      if (!note) return;
      const deny = note.querySelector(".post-selection__insurance-deny");
      const approve = note.querySelector(".post-selection__insurance-approve");
      const insuranceInput = this._getInsuranceInput();
      const active = !!(insuranceInput && insuranceInput.checked);
      note.style.display = active ? "" : "none";
      if (deny) deny.style.display = "none";
      if (approve) approve.style.display = active ? "flex" : "none";
    }
  
    _createListItem(title, price, imgSrc, variantId) {
      const template = document.getElementById("listItemTemplate");
      if (!template) return null;
      
      const clone = template.content.cloneNode(true);
  
      const titleElement = clone.querySelector(".post-selection__item-product-title");
      const priceElement = clone.querySelector(".post-selection__item-product-price");
      const imgElement = clone.querySelector(".post-selection__overview-img");
      const itemElement = clone.querySelector(".post-selection__overview-item");
      
      if (titleElement) titleElement.textContent = title;
      if (priceElement) priceElement.textContent = price;
      if (imgElement) imgElement.src = imgSrc;
      if (itemElement) itemElement.setAttribute("data-variant", variantId);
  
      return clone;
    }
  
    _addItemToList(title, price, imgSrc, variantId) {
      if (!this.overviewList) return;
      
      this.overviewList.style.display = "flex";
      const listItem = this._createListItem(title, price, imgSrc, variantId);
      if (listItem) {
        this.overviewList.appendChild(listItem);
      }
    }
  
    _removeListItem(variantId) {
      if (!this.overviewList) return;
      
      const listItem = this.overviewList.querySelector(
        `.post-selection__overview-item[data-variant='${variantId}']`
      );
      if (listItem) {
        listItem.remove();
      }
      
      const checkBoxes = document.querySelectorAll(`input#variant-${variantId}`);
      checkBoxes.forEach((checkBox) => {
        if (checkBox) {
          checkBox.checked = false;
        }
      });
      
      const checkBoxesCross = document.querySelectorAll(`input#variant-${variantId}-cross`);
      checkBoxesCross.forEach((checkBox) => {
        if (checkBox) {
          checkBox.checked = false;
        }
      });
  
      if (this.overviewList.children.length === 0) {
        this.overviewList.style.display = "none";
      }
      
      this._updatePrices();
      this._checkInsuranceItems();
      this._checkCrossVariant();
    }
  
    _formatPrice(priceInCents) {
    // FAT-218: prices >= €100 are shown without decimals ("999,-"),
    // prices < €100 keep two decimals ("29,99"). Relies on the Shopify
    // money format being set to two decimals.
       const formatted = this.formatMoney(priceInCents);
       const numericCents = parseInt(String(priceInCents).replace(/\./g, ""), 10);

       if (!isNaN(numericCents) && numericCents >= 10000) {
           return formatted.replace(",00", ",-");
       }

       return formatted;
    }
    formatMoney(cents, format = "") {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || window.themeVariables.settings.moneyFormat;
        function defaultTo(value2, defaultValue) {
            return value2 == null || value2 !== value2 ? defaultValue : value2;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
            return 0;
            }
            number = (number / 100).toFixed(precision);
            let parts = number.split("."),
            dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
            case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
            case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
            case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
            case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
            case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
            case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
            case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
        } else {
            return formatString.replace(placeholderRegex, value);
        }
        }
  
    _updateURL() {
      const url = new URLParse(window.location.href, true);
      const newVariantValue = this.selectedVariant;
      url.query.variant = newVariantValue;
      window.history.replaceState(null, null, url.toString());
    }
  
    _getCart() {
      return fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }).then((response) => response.json());
    }
  
    _addVariantsToCart(items, cb = null) {
      const drawerId = document
        .querySelector("cart-drawer")
        .parentElement.id.replace("shopify-section-", "");
        
      let str = "";
      items.length > 0 ? (this.drawerOpened = true) : (this.drawerOpened = false);
      items.length > 0 ? (str = `/variants/${items[0].id}`) : false;
      
      let formData = {
        items: items,
        sections: `variant-added,${drawerId}`,
        sections_url: str,
      };
      
      if (this.drawerShow) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections: ["variant-added"] },
          })
        );
      }
  
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          this.drawerShow && this.drawerOpened
            ? this._openDrawer(responseJson)
            : false;
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          if (cb) {
            cb();
          }
          this.drawerShow ? this._closeModal() : false;
        });
    }
  
    async _openDrawer(responseJson) {
      const cartContent = await (await fetch(`/cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items")
              ? responseJson["items"]
              : [responseJson],
            cart: cartContent,
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );
    }
  
    _closeModal() {
      document
        .querySelector(".micromodal-slide [data-micromodal-close] ")
        .click();
      this.checkoutBtn.querySelector(".post-selection__checkout-btn-inner").style.display = "flex";
      this.checkoutBtn.querySelector(".post-selection__btn-loader").style.display = "none";
    }
  
    _removeVariantsFromCart(variantToRemove, cb = null) {
      let updates = {
        [variantToRemove]: 0,
      };
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          if (cb) {
            cb();
          }
        });
    }
  }
  